module.exports = __webpack_public_path__ + "static/img/1.1ca18c25.png";